// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextFieldProps } from "@ces/MobiusOverrides/TextField/TextField";
import { xScreen } from "@ces/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

customerAddressFormFieldStyles.container = {
    gap: 0,
    offsetCss: css`
        gap: 16px 22px;
        &&&& {
            ${xScreen("lt", "xs")} {
                & > ${GridItemStyle} {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            }
        }
    `,
};

customerAddressFormFieldStyles.emailGridItem = {
    width: 12,
    css: css`
        flex-basis: unset;
        min-width: 50%;
        &&&& {
            flex-grow: 1;
        }
    `,
};

customerAddressFormFieldStyles.companyNameGridItem = {
    width: 6,
    css: css`
        flex-basis: unset;
        &&&& {
            flex-grow: 1;
        }
    `,
};

customerAddressFormFieldStyles.attentionGridItem = {
    width: 6,
    css: css`
        flex-basis: unset;
        &&&& {
            flex-grow: 1;
        }
    `,
};

customerAddressFormFieldStyles.stateGridItem = {
    width: 6,
    css: css`
        flex-basis: unset;
        &&&& {
            flex-grow: 1;
        }
    `,
};

customerAddressFormFieldStyles.postalCodeGridItem = {
    width: 6,
    css: css`
        flex-basis: unset;
        &&&& {
            flex-grow: 1;
        }
    `,
};

customerAddressFormFieldStyles.firstNameText = {
    placeholder: translate("Username"),
    type: "firstName",
} as TextFieldProps;

customerAddressFormFieldStyles.lastNameText = {
    placeholder: translate("Last Name"),
    type: "lastName",
} as TextFieldProps;

customerAddressFormFieldStyles.companyNameText = {
    placeholder: translate("Company Name"),
    type: "companyName",
} as TextFieldProps;

customerAddressFormFieldStyles.attentionText = {
    placeholder: translate("Contact Name"),
} as TextFieldProps;

customerAddressFormFieldStyles.address1Text = {
    placeholder: translate("Address1"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address2Text = {
    placeholder: translate("Address2"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address3Text = {
    placeholder: translate("Address3"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.address4Text = {
    placeholder: translate("Address4"),
    type: "address",
} as TextFieldProps;

customerAddressFormFieldStyles.cityText = {
    placeholder: translate("City"),
    type: "city",
} as TextFieldProps;

customerAddressFormFieldStyles.postalCodeText = {
    placeholder: translate("Postal Code"),
    type: "postalCode",
} as TextFieldProps;

customerAddressFormFieldStyles.phoneText = {
    placeholder: translate("(xxx) xxx-xxxx"),
    type: "phone",
} as TextFieldProps;

customerAddressFormFieldStyles.faxText = {
    placeholder: translate("Fax"),
} as TextFieldProps;

customerAddressFormFieldStyles.emailText = {
    placeholder: translate("Email"),
    type: "email",
} as TextFieldProps;
